(() => {
  const resolvePhase = (element) => {
    const mode = element.dataset.mode;

    if (mode === 'before' || mode === 'transition') {
      return mode;
    }

    const transitionAt = Date.parse(element.dataset.transitionAt || '');
    return Number.isFinite(transitionAt) && Date.now() >= transitionAt ? 'transition' : 'before';
  };

  class LogisticsPhase extends HTMLElement {
    connectedCallback() {
      this.updatePhase();
    }

    updatePhase() {
      const phase = resolvePhase(this);
      this.dataset.logisticsPhase = phase;

      if (this.dataset.transitionOnly === 'true') {
        this.hidden = phase !== 'transition';
      } else {
        this.hidden = false;
      }

      return phase;
    }
  }

  class LogisticsNotice extends LogisticsPhase {
    connectedCallback() {
      this.phase = resolvePhase(this);
      this.dataset.logisticsPhase = this.phase;
      this.dismissButtons = this.querySelectorAll('[data-logistics-dismiss]');
      this.dialog = this.querySelector('[role="dialog"]');
      this.previouslyFocused = null;
      this.onDismiss = this.close.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);

      this.dismissButtons.forEach((button) => button.addEventListener('click', this.onDismiss));
      document.addEventListener('keydown', this.onKeydown);

      const designMode = this.dataset.designMode === 'true';
      const storageKey = `${this.dataset.storageKey}:${this.phase}`;
      let dismissed = false;

      if (!designMode) {
        try {
          dismissed = window.sessionStorage.getItem(storageKey) === 'dismissed';
        } catch (error) {
          dismissed = false;
        }
      }

      if (dismissed) return;

      const delay = designMode ? 0 : Number.parseInt(this.dataset.delay || '0', 10);
      this.openTimer = window.setTimeout(() => this.open(), Number.isFinite(delay) ? delay : 0);
    }

    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
      this.dismissButtons?.forEach((button) => button.removeEventListener('click', this.onDismiss));
      document.removeEventListener('keydown', this.onKeydown);
    }

    open() {
      this.previouslyFocused = document.activeElement;
      this.hidden = false;
      this.setAttribute('aria-hidden', 'false');

      window.requestAnimationFrame(() => {
        this.classList.add('is-visible');
        this.dialog?.focus({ preventScroll: true });
      });
    }

    close() {
      if (this.hidden) return;

      this.classList.remove('is-visible');
      this.setAttribute('aria-hidden', 'true');

      try {
        window.sessionStorage.setItem(`${this.dataset.storageKey}:${this.phase}`, 'dismissed');
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browser contexts.
      }

      window.setTimeout(() => {
        this.hidden = true;
        this.previouslyFocused?.focus?.({ preventScroll: true });
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500);
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && !this.hidden) {
        this.close();
      }
    }
  }

  const updateLogisticsAnnouncementBars = (container = document) => {
    container.querySelectorAll('[data-logistics-announcement]').forEach((bar) => {
      if (resolvePhase(bar) !== 'transition') return;

      const transitionText = bar.dataset.transitionText;
      if (!transitionText) return;

      bar.querySelectorAll('.announcement-bar__item-inner').forEach((item) => {
        item.textContent = transitionText;
      });
    });
  };

  if (!customElements.get('logistics-phase')) {
    customElements.define('logistics-phase', LogisticsPhase);
  }

  if (!customElements.get('logistics-notice')) {
    customElements.define('logistics-notice', LogisticsNotice);
  }

  updateLogisticsAnnouncementBars();

  document.addEventListener('shopify:section:load', (event) => {
    updateLogisticsAnnouncementBars(event.target);
  });
})();
